<template>
  <div
    class="card sc-vizlet-reorder-wrap"
    ref="screen"
    v-if="
      viz1.visibleFlag === true &&
        viz1.vizType !== 'report' &&
        viz1.vizletCardDisableFlag == false
    "
    v-bind:style="vizletCardStyle"
    :class="[
      $store.state.bannerStatus
        ? vizCount === 1
          ? 'single-viz-height-banner-true'
          : 'single-viz-max-height-banner-true'
        : vizCount === 1
        ? 'single-viz-height-banner-false'
        : 'single-viz-max-height-banner-false',
      { 'fixed-screen-width': $store.state.fixedScreen },
      reorderWrapClass,
      {
        'sc-vizlet-config-selected': configSelected,
        'sc-vizlet-config-selectable': configEditMode && vizCount > 1,
      },
    ]"
    data-cfg-reorder="vizlet"
    :data-cfg-reorder-index="reorderIndex"
  >
    <button
      v-if="configEditMode && vizCount > 1"
      type="button"
      class="cfg-drag-handle cfg-drag-handle--widget"
      title="Drag to reorder chart"
      aria-label="Drag to reorder chart"
      @mousedown.prevent="$emit('reorder-drag-start', reorderIndex, $event)"
    >⋮⋮</button>
    <!-- Tab indicator in header -->
    <div class="card-header p-0" v-if="vizCount !== 1">
      <vizlet-header
        ref="vizletHeader"
        :viz1="viz1"
        :vizData="originalData"
        :currentMenuActionIconsData="currentMenuActionIconsData"
        :mCurrentMenuActionIconsData="mCurrentMenuActionIconsData"
        :vizCount="vizCount"
        :config-edit-mode="configEditMode"
        :searchQuery.sync="searchQuery"
        :iconOnChangeFlag="iconOnChangeFlag"
        :isCollapsed="isCollapsed"
        :format="format"
        :total="total"
        :headerMap="effectiveHeaderMap"
        :allHeaderMap="effectiveAllHeaderMap"
        :reportHeaderNewColumnTitles="reportHeaderNewColumnTitles"
        @vizlet-title-save="$emit('vizlet-title-save', $event)"
        @toggle-body="toggleCardBody"
        @toggle-width="toggleCardWidth"
        @action="handleActionIconFunctionCall"
        @reset-filter="resetFilter"
        @search="handleSearch"
        @save-columns="handleSaveColumns"
        @preview-columns="handlePreviewColumns"
        @create-derived-column="handleCreateDerivedColumn"
      />
    </div>

    <!-- Resize handles -->
    <div
      class="resize-handle"
      @mousedown.prevent="startBorderResize($event, 'se')"
    >
      ⇲
    </div>
    <div
      class="resize-border resize-border-right"
      @mousedown.prevent="startBorderResize($event, 'e')"
    ></div>
    <div
      class="resize-border resize-border-bottom"
      @mousedown.prevent="startBorderResize($event, 's')"
    ></div>

    <!-- Card Body Content (unchanged) -->
    <div
      v-if="
        !(
          viz1.viztypeName === 'TableBar' ||
          viz1.viztypeName === 'Tabulator' ||
          viz1.viztypeName === 'fileUpload' || viz1.viztypeName==='salesDashboardv1' || viz1.viztypeName==='salesDashboard' ||
          viz1.viztypeName === 'menuConfig' ||
          viz1.viztypeName === 'aiMenuConfig'
        )
      "
      class="card-body"
      v-show="!isCollapsed"
    >
      <div
        v-if="tooltipTitle === 'Lower the Better'"
        align="right"
        v-bind:style="{ color: colorClass }"
      >
        <i class="fa fa-arrow-circle-down" :title="tooltipTitle"></i>
      </div>
      <div
        v-if="tooltipTitle === 'Higher the Better'"
        align="right"
        v-bind:style="{ color: colorClass }"
      >
        <i class="fa fa-arrow-circle-up" :title="tooltipTitle"></i>
      </div>

      <div
        :id="id"
        ref="r1c1"
        :class="viz1.scrollbarFlag ? 'scrollmenu2' : 'scrollmenu'"
      ></div>
    </div>

    <div
      v-if="viz1.viztypeName == 'TableBar'"
      class="card-body p-0"
      v-show="!isCollapsed"
    >
      <div
        v-if="tooltipTitle === 'Lower the Better'"
        align="right"
        v-bind:style="{ color: colorClass }"
      >
        <i class="fa fa-arrow-circle-down" :title="tooltipTitle"></i>
      </div>
      <div
        v-if="tooltipTitle === 'Higher the Better'"
        align="right"
        v-bind:style="{ color: colorClass }"
      >
        <i class="fa fa-arrow-circle-up" :title="tooltipTitle"></i>
      </div>

      <div
        :id="id"
        ref="r1c2"
        :class="
          vizCount > 1
            ? 'multi-viz'
            : $store.state.bannerStatus
            ? 'r1c2true'
            : 'r1c2false'
        "
        :style="dynamicStyle"
      ></div>
    </div>

    <b-modal
        ref="download-format-modal"
        title="Download data"
        centered
        @shown="onDownloadFormatModalShown"
    >
      <div class="download-format-modal-body">
        <p class="text-muted small mb-2">You are about to download:</p>
        <div class="d-flex align-items-start mb-2">
          <i class="fa fa-file-o text-secondary mt-1 mr-2" aria-hidden="true"></i>
          <div>
            <div class="font-weight-bold">{{ downloadModalFileName }}</div>
            <div class="download-format-meta small text-muted pl-0 mt-1">
              <div>which is: {{ downloadModalTypeLine }}</div>
              <div>from: {{ downloadModalFromLine }}</div>
            </div>
          </div>
        </div>

        <p class="font-weight-bold mb-2 mt-3">Choose download format:</p>
        <b-form-radio-group
            v-model="downloadFormatChoice"
            stacked
            class="download-format-radios"
        >
          <b-form-radio value="xlsx">XLSX (Excel)</b-form-radio>
          <b-form-radio value="csv">CSV</b-form-radio>
        </b-form-radio-group>
      </div>

      <template #modal-footer>
        <div class="w-100 d-flex justify-content-end">
          <b-button variant="primary"  class="mr-2"  @click="confirmDownloadFormatModal">OK</b-button>
          <b-button variant="outline-secondary" @click="cancelDownloadFormatModal">Cancel</b-button>
        </div>
      </template>
    </b-modal>

    <b-modal
      ref="download-modal"
      title="Downloading Data"
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
      hide-footer
    >
      <div class="text-center">
        <b-spinner variant="primary" class="mb-3"></b-spinner>
        <p class="mb-0">Preparing your download... Please wait.</p>
      </div>
    </b-modal>

    <div
      v-if="viz1.viztypeName === 'Tabulator' && tabFlag"
      class="card-body p-1"
      v-show="!isCollapsed"
    >
      <tabulator-report-table
        ref="tabulatorReport"
        :id="id"
        class="scrollmenuRepo"
        :viz1="viz1"
        :tabulatorData="tabulatorData"
        :filters="filtersForDashboard"
        :vizCount="vizCount"
      />
    </div>

    <div
      v-if="viz1.viztypeName === 'salesDashboard'"
      class="card-body p-1"
      v-show="!isCollapsed"
    >
      <sales-dashboard
        ref="salesDashboard"
        class="scrollmenuRepo"
        :id="id"
        :viz1="viz1"
        :filters="filtersForDashboard"
        :sales-data="salesData"
      />
    </div>

    <div
      v-if="viz1.viztypeName === 'salesDashboardv1'"
      class="card-body p-1"
      v-show="!isCollapsed"
    >
      <sales-dashboard-v1
        ref="salesDashboardv1"
        class="scrollmenuRepo"
        :id="id"
        :viz1="viz1"
        :filters="filtersForDashboard"
        :sales-data="salesData"
      />
    </div>

    <div
      v-if="viz1.viztypeName === 'fileUpload'"
      class="card-body p-2"
      v-show="!isCollapsed"
    >
      <file-upload />
    </div>

    <div v-if="viz1.viztypeName === 'menuConfig'" v-show="!isCollapsed">
      <menu-config
        ref="menuConfig"
        :selectedOptions="selectedOptions"
        :embedded="true"
        :filters="filtersForDashboard"
      />
    </div>

    <div v-if="viz1.viztypeName === 'aiMenuConfig'" v-show="!isCollapsed">
      <ai-menu-config
          ref="aiMenuConfig"
          :selectedOptions="selectedOptions"
          :embedded="true"
          :filters="filtersForDashboard"
      />
    </div>
    <b-modal ref="comment-box" @ok="postAnnotation()" :title="annotationTitle">
      <b-form-group label="Comment">
        <textarea
          rows="3"
          cols="40"
          v-model="cmnt"
          placeholder="Write a comment..."
        ></textarea>
      </b-form-group>
    </b-modal>

    <div>
      <modal
        v-if="showErrorModal"
        :isVisible="showErrorModal"
        @close="showErrorModal = false"
        :title="title"
      >
      </modal>
    </div>
  </div>
  <div v-else-if="viz1.vizletCardDisableFlag == true" :id="id" ref="r1c1"></div>
</template>

<script>
import { FwVizChartInfo } from "../models";
import axios from "axios";
import moment from "moment";
import { saveSvgAsPng } from "save-svg-as-png";
import * as d3 from "d3";
import TabulatorReportTable from "./reports/tabulator-report-table.vue";
import Modal from "./Modal.vue";
import SalesDashboard from "@/components/SalesDashboard.vue";
import SalesDashboardV1 from "@/components/SalesDashboardV1.vue";
import { getAnnotationMsgcount, runFetchCsvExport } from "@/common/functions";
import FileUpload from "@/components/file-upload.vue";
import { apiAbort } from "@/common/apiAbort";
import { extractFailedFetchQueryFromError } from "@/common/sqlDataSqlAlias";
import VizletHeader from "@/components/VizletHeader.vue";
import MenuConfig from "@/components/admin/menu-config.vue";
import AiMenuConfig from "@/components/admin/ai-menu-config.vue";
// import ProductCategory from "@/components/ProductCategory.vue";

/** Show “new column” styling only within this window after `headerConfig.createTimestamp`. */
const REPORT_HEADER_NEW_HIGHLIGHT_MS = 48 * 60 * 60 * 1000;

export default {
  name: "VizletSettings",
  components: {
    AiMenuConfig,
    FileUpload,
    TabulatorReportTable,
    Modal,
    SalesDashboard,
    SalesDashboardV1,
    VizletHeader,
    MenuConfig,
  },
  props: {
    viz1: Object,
    styles: String,
    propTime: Date,
    screenlet: Number,
    filterParam: Object,
    selectedFilters: Object,
    width: Number,
    height: Number,
    vizCount: Number,
    configEditMode: { type: Boolean, default: false },
    configSelected: { type: Boolean, default: false },
    reorderIndex: { type: Number, default: 0 },
    reorderWrapClass: { type: Object, default: () => ({}) },
    filterFlag: Boolean,
    selectedOptions: Object,
  },
  watch: {
    // Reload when the user applies filters — do not deep-watch all props (viz1, filterParam,
    // selectedOptions churn during layout/header config and would fire this hundreds of times).
    filterFlag: {
      handler(newVal) {
        if (newVal === true) {
          this.loadViz()
            .then(() => {
              this.$emit("viz-loaded");
            })
            .catch((error) => {
              console.error("Error loading viz:", error);
              this.$emit("viz-loaded");
            });
        }
      },
    },
    headerHeight: {
      handler() {
        this.handleResize();
      },
      immediate: true,
    },
    width: {
      handler() {
        this.handleResize();
      },
      immediate: true,
    },
    height: {
      handler() {
        this.handleResize();
      },
      immediate: true,
    },
    tabulatorData: {
      handler(newData) {
        // Delay the execution until the component is fully mounted
        this.$nextTick(() => {
          if (this.$refs.tabulatorReport) {
            this.$refs.tabulatorReport.loadTabulatorData(newData);
          }
        });
      },
      deep: true,
      immediate: true,
    },
    vizHeight: {
      handler() {
        this.handleResize();
      },
      immediate: true,
    },
    vizWidth: {
      handler() {
        this.handleResize();
      },
      immediate: true,
    },
  },
  data: () => ({
    searchQuery: "",
    originalData: null, // To store unfiltered data
    filtersForDashboard: {},
    showFSButton: true,
    showModal: false,
    download: [],
    cleanedDownload: [],
    headerData: [],
    momentAll: "",
    cmnt: "",
    annotations: [],
    searching: false,
    annotationTitle: "",
    // filterPeriodLevel1:"",
    f: {},
    iconOnChangeFlag: [],
    checkbox: false,
    gridflag: false,
    showValuesFlag: true,
    currentMenuActionIconsData: [],
    mCurrentMenuActionIconsData: [],
    id: `VIZ-${new Date().getTime()}`,
    grid_id: `VIZ-${new Date().getTime()}` + "grid",
    vizletCardStyle: "",
    tooltipTitle: "",
    colorClass: "#41ab5d",
    vizTypeName: "",
    total: null,
    showErrorModal: false,
    title: "",
    tabulatorData: [],
    tabFlag: false,
    salesData: [],
    downloadLoading: false,
    downloadResponse: null,
    isCollapsed: false,
    showResize: false,
    isResizing: false,
    startWidth: 0,
    startHeight: 0,
    startX: 0,
    startY: 0,
    vizWidth: 0,
    vizHeight: 0,
    chartCleanup: null,
    pendingDownloadFormat: 'xlsx',
    downloadFormatChoice: 'xlsx',
    headerConfig: null,
    /** Default column map: snapshot of `viz1.reportHeaderColumnDp` taken in loadHeaderConfig *before* applying GET saved layout */
    tableBarHeaderBaseline: null,
  }),
  computed: {
    downloadModalPreviewBase() {
      const v = this.viz1;
      const uid = this.$store.state.user && this.$store.state.user.userId;
      if (!v || uid == null) return 'export';
      return `${uid}_${v.vizletTitleDpName || 'viz'}_${moment().format('YYYY-MM-DD_hhmm')}`;
    },
    downloadModalFileName() {
      const ext = this.downloadFormatChoice === 'xlsx' ? 'xlsx' : 'csv';
      return `${this.downloadModalPreviewBase}.${ext}`;
    },
    downloadModalTypeLine() {
      return this.downloadFormatChoice === 'xlsx'
        ? 'Microsoft Excel Workbook (.xlsx)'
        : 'Comma-separated values (.csv)';
    },
    downloadModalFromLine() {
      const name = (this.viz1 && this.viz1.vizletTitleDpName) ? String(this.viz1.vizletTitleDpName) : 'export';
      return name.replace(/\//g, '-');
    },
    dynamicStyle() {
      const isSmallScreen = window.innerWidth <= 1300;

      // Fallback: if no headerHeight, use vh directly
      if (!this.headerHeight) {
        return {
          maxHeight: isSmallScreen ? "81vh" : "74vh",
          overflow: "auto",
        };
      }

      // Adjust based on screen size
      const baseVH = isSmallScreen ? 81 : 82;

      return {
        maxHeight: `calc(${baseVH}vh - ${this.headerHeight}px)`,
        overflow: "auto",
      };
    },
    fixedScreen() {
      return this.$store.state.fixedScreen;
    },
    effectiveHeaderMap() {
      if (
        this.headerConfig &&
        this.headerConfig.reportHeaderColumnDp &&
        typeof this.headerConfig.reportHeaderColumnDp === "object"
      ) {
        return this.headerConfig.reportHeaderColumnDp;
      }
      return this.viz1.reportHeaderColumnDp || {};
    },
    effectiveAllHeaderMap() {
      if (
        this.headerConfig &&
        this.headerConfig.allHeaderColumnDp &&
        typeof this.headerConfig.allHeaderColumnDp === "object"
      ) {
        return this.headerConfig.allHeaderColumnDp;
      }
      return this.viz1.allHeaderColumnDp || {};
    },
    reportHeaderNewColumnTitles() {
      const v = this.viz1;
      const a = v && v.reportHeaderNewColumnTitles;
      return Array.isArray(a) ? a : [];
    },
  },
  beforeDestroy() {
    console.log("clen", this.chartCleanup);
    if (typeof this.chartCleanup === "function") {
      console.log("Cleaning up ETL Chart intervals...");
      this.chartCleanup(); // This calls your clearInterval logic
    }
  },
  methods: {
    /** Menu template `reportHeaderColumnDp` from loadState (unaffected by user saves on viz1 prop). */
    getMenuTemplateReportHeaderColumnDpFromStore() {
      try {
        const list = this.$store.state.fwConfigScreenElement;
        const v = this.viz1;
        if (!v || v.viztypeName !== "TableBar" || !Array.isArray(list)) {
          return null;
        }
        const menuId =
          v.menu_id ||
          (this.$route &&
            this.$route.params &&
            this.$route.params.submenuId) ||
          (this.$route && this.$route.params && this.$route.params.menuId);
        const vizletId = v.vizletId;
        const datasqlId = v.datasqlId != null ? String(v.datasqlId) : null;
        if (!menuId || !vizletId || !datasqlId) return null;
        const row = list.find(
          (el) =>
            el &&
            el.menuId === menuId &&
            String(el.vizletId) === String(vizletId) &&
            String(el.datasqlId) === datasqlId,
        );
        const m = row && row.reportHeaderColumnDp;
        return m && typeof m === "object" ? m : null;
      } catch (e) {
        return null;
      }
    },
    /** When viz identity changes, seed baseline from store template or props. */
    syncTableBarHeaderBaselineIfNeeded() {
      const v = this.viz1;
      if (!v || v.viztypeName !== "TableBar") {
        this._tableBarHeaderIdentity = null;
        this.tableBarHeaderBaseline = null;
        return;
      }
      const id = [v.vizletId, v.datasqlId, this.screenlet].join("|");
      if (this._tableBarHeaderIdentity !== id) {
        this._tableBarHeaderIdentity = id;
        const fromStore = this.getMenuTemplateReportHeaderColumnDpFromStore();
        if (
          fromStore &&
          typeof fromStore === "object" &&
          Object.keys(fromStore).length > 0
        ) {
          this.tableBarHeaderBaseline = { ...fromStore };
        } else {
          const raw = v.reportHeaderColumnDp;
          this.tableBarHeaderBaseline =
            raw && typeof raw === "object" ? { ...raw } : {};
        }
      }
    },
    /** Parse server `createTimestamp` to epoch ms, or null if missing/invalid. */
    parseHeaderConfigCreateTimeMs(headerConfig) {
      if (!headerConfig || typeof headerConfig !== "object") return null;
      const raw =
        headerConfig.createTimestamp ?? headerConfig.create_timestamp;
      if (raw == null || raw === "") return null;
      if (typeof raw === "number" && Number.isFinite(raw)) {
        const d = new Date(raw);
        return Number.isNaN(d.getTime()) ? null : d.getTime();
      }
      /* Jackson often serializes LocalDateTime as [y, mo, d, h, mi, s, nano] */
      if (Array.isArray(raw)) {
        const y = Number(raw[0]);
        const mo = Number(raw[1]);
        const d = Number(raw[2]);
        const h = Number(raw[3] ?? 0);
        const mi = Number(raw[4] ?? 0);
        const s = Number(raw[5] ?? 0);
        let ms = 0;
        if (raw.length > 6 && raw[6] != null) {
          const nano = Number(raw[6]);
          if (Number.isFinite(nano)) ms = Math.floor(nano / 1e6);
        }
        if (![y, mo, d].every((n) => Number.isFinite(n))) return null;
        const dt = new Date(y, mo - 1, d, h, mi, s, ms);
        return Number.isNaN(dt.getTime()) ? null : dt.getTime();
      }
      if (typeof raw === "object" && raw !== null && "epochSecond" in raw) {
        const es = Number(raw.epochSecond);
        const nano = Number(raw.nano ?? 0);
        if (!Number.isFinite(es)) return null;
        return es * 1000 + (Number.isFinite(nano) ? Math.floor(nano / 1e6) : 0);
      }
      if (typeof raw === "string") {
        const m = moment(raw);
        if (m.isValid()) return m.valueOf();
        const isoish = raw.includes("T") ? raw : raw.replace(" ", "T");
        const d = new Date(isoish);
        return Number.isNaN(d.getTime()) ? null : d.getTime();
      }
      return null;
    },
    /** True only when saved layout is younger than 48h (client clock vs server timestamp). */
    isReportHeaderNewHighlightActive() {
      const t = this.parseHeaderConfigCreateTimeMs(this.headerConfig);
      if (t == null) return false;
      const ageMs = Date.now() - t;
      return ageMs >= 0 && ageMs < REPORT_HEADER_NEW_HIGHLIGHT_MS;
    },
    /** Keys in current layout that are not in the screen-default map (saved / custom columns). */
    recomputeReportHeaderNewColumnTitles() {
      const v = this.viz1;
      if (!v || v.viztypeName !== "TableBar") {
        return;
      }
      let base = this.tableBarHeaderBaseline;
      const fromStore = this.getMenuTemplateReportHeaderColumnDpFromStore();
      if (
        fromStore &&
        typeof fromStore === "object" &&
        Object.keys(fromStore).length > 0 &&
        (!base || typeof base !== "object" || Object.keys(base).length === 0)
      ) {
        base = { ...fromStore };
      }
      if (!base || typeof base !== "object") {
        this.$set(v, "reportHeaderNewColumnTitles", []);
        return;
      }
      const cur = v.reportHeaderColumnDp || {};
      const newTitles = Object.keys(cur).filter(
        (k) => !Object.prototype.hasOwnProperty.call(base, k),
      );
      const toShow =
        newTitles.length > 0 && this.isReportHeaderNewHighlightActive()
          ? newTitles
          : [];
      this.$set(v, "reportHeaderNewColumnTitles", toShow);
    },
    async loadHeaderConfig() {
      try {
        try {
          const viz = this.viz1 || {};
          if (viz.viztypeName !== "TableBar") return;

          const menuId =
            viz.menu_id ||
            (this.$route &&
              this.$route.params &&
              this.$route.params.submenuId) ||
            (this.$route && this.$route.params && this.$route.params.menuId);
          const vizletId = viz.vizletId;
          const datasqlId = viz.datasqlId != null ? String(viz.datasqlId) : null;

          if (!menuId || !vizletId || !datasqlId) {
            return;
          }

          /* Snapshot menu default *before* await — after await, viz1 may already match saved layout from a parent prop update. */
          const tableBarDefaultHeaderSnapshot =
            viz.reportHeaderColumnDp && typeof viz.reportHeaderColumnDp === "object"
              ? { ...viz.reportHeaderColumnDp }
              : {};

          const resp = await axios.get("/api/viz-header-config", {
            params: { menuId, vizletId, datasqlId },
            validateStatus: (s) => s === 200 || s === 204 || s === 404,
          });

          if (resp.status !== 200 || !resp.data) {
            return;
          }

          const serverCfg = resp.data;
          console.log("serverCfg", serverCfg);
          this.headerConfig = serverCfg;

          if (
            serverCfg.reportHeaderColumnDp &&
            typeof serverCfg.reportHeaderColumnDp === "object"
          ) {
            const fromStore = this.getMenuTemplateReportHeaderColumnDpFromStore();
            const hasStore =
              fromStore &&
              typeof fromStore === "object" &&
              Object.keys(fromStore).length > 0;
            this.tableBarHeaderBaseline = hasStore
              ? { ...fromStore }
              : { ...tableBarDefaultHeaderSnapshot };
            const map = serverCfg.reportHeaderColumnDp;
            const order = serverCfg.reportHeaderColumnDpOrder;
            if (Array.isArray(order) && order.length > 0) {
              const ordered = {};
              order.forEach((key) => {
                if (Object.prototype.hasOwnProperty.call(map, key)) {
                  ordered[key] = map[key];
                }
              });
              Object.keys(map).forEach((key) => {
                if (!Object.prototype.hasOwnProperty.call(ordered, key)) {
                  ordered[key] = map[key];
                }
              });
              this.viz1.reportHeaderColumnDp = ordered;
            } else {
              this.viz1.reportHeaderColumnDp = { ...map };
            }
          }

          if (
            serverCfg.allHeaderColumnDp &&
            typeof serverCfg.allHeaderColumnDp === "object"
          ) {
            this.viz1.allHeaderColumnDp = { ...serverCfg.allHeaderColumnDp };
          }

          if (
            serverCfg.derivedColumn &&
            typeof serverCfg.derivedColumn === "object"
          ) {
            this.$set(this.viz1, "derivedColumn", {
              ...serverCfg.derivedColumn,
            });
          }

          this.$emit("header-config-loaded", serverCfg);
        } finally {
          this.recomputeReportHeaderNewColumnTitles();
        }
      } catch (e) {
        this.recomputeReportHeaderNewColumnTitles();
      }
    },
    refresh() {
      this.$emit("refresh");
      this.loadViz();
    },
    startBorderResize(e, direction = "se") {
      this.isResizing = true;
      this.resizeDirection = direction;

      const card = this.$refs.screen;
      if (card) {
        const rect = card.getBoundingClientRect();
        this.startWidth = rect.width;
        this.startHeight = rect.height;
        this.startX = e.clientX;
        this.startY = e.clientY;

        document.addEventListener("mousemove", this.handleBorderResize);
        document.addEventListener("mouseup", this.stopBorderResize);
      }
      e.preventDefault();
    },

    handleBorderResize(e) {
      if (!this.isResizing) return;

      const deltaX = e.clientX - this.startX;
      const deltaY = e.clientY - this.startY;

      let newWidth = this.startWidth;
      let newHeight = this.startHeight;

      // Handle different resize directions
      switch (this.resizeDirection) {
        case "e": // east (right)
          newWidth = this.startWidth + deltaX;
          break;
        case "s": // south (bottom)
          newHeight = this.startHeight + deltaY;
          break;
        case "se": // south-east (bottom-right)
          newWidth = this.startWidth + deltaX;
          newHeight = this.startHeight + deltaY;
          break;
      }

      // Apply minimum dimensions
      this.vizWidth = Math.max(200, newWidth);
      this.vizHeight = Math.max(150, newHeight);

      this.updateCardSize();
    },

    stopBorderResize() {
      this.isResizing = false;
      this.resizeDirection = null;
      document.removeEventListener("mousemove", this.handleBorderResize);
      document.removeEventListener("mouseup", this.stopBorderResize);
      this.handleResize(); // Trigger your existing resize logic
    },

    updateCardSize() {
      const card = this.$refs.screen;
      if (card) {
        card.style.setProperty("flex", "0 0 auto", "important");
        card.style.setProperty("width", `${this.vizWidth}px`, "important");
        card.style.setProperty("height", `${this.vizHeight}px`, "important");
      }

      this.vizletCardStyle = {
        minWidth: `${this.vizWidth}px !important`,
        height: `${this.vizHeight}px !important`,
      };
      this.handleResize();
    },

    resetFilter() {
      this.$store.commit("setResetSortFlag", true);
      this.handleResize();
    },
    handleCreateDerivedColumn(payload) {
      const alias = payload && payload.alias;
      const templateFormula = payload && payload.templateFormula;
      const userColumns = payload && payload.userColumns;
      const formula = payload && payload.formula;
      const formulaDisplay = payload && payload.formulaDisplay;
      if (!alias || !templateFormula) return;
      const entry = {
        templateFormula,
        userColumns: userColumns || [],
        _userCreated: true,
      };
      if (formula != null && String(formula).trim() !== "") {
        entry.formula = String(formula);
      }
      if (formulaDisplay != null && String(formulaDisplay).trim() !== "") {
        entry.formulaDisplay = String(formulaDisplay);
      }
      const patch = {
        ...(this.headerConfig || {}),
        derivedColumn: {
          ...((this.headerConfig && this.headerConfig.derivedColumn) || {}),
          [alias]: entry,
        },
      };
      this.headerConfig = patch;
      this.$set(this.viz1, "derivedColumn", patch.derivedColumn);
    },
    applyColumnLayoutFromPayload(payload) {
      let newHeaderMap;
      let derivedColumnFromChild = null;
      let tableBarSqlFromChild = null;
      if (
        payload &&
        typeof payload === "object" &&
        Object.prototype.hasOwnProperty.call(payload, "reportHeaderColumnDp")
      ) {
        newHeaderMap = payload.reportHeaderColumnDp;
        derivedColumnFromChild = payload.derivedColumn;
        tableBarSqlFromChild = payload.tableBarSql;
      } else {
        newHeaderMap = payload;
      }

      if (
        derivedColumnFromChild &&
        typeof derivedColumnFromChild === "object"
      ) {
        this.headerConfig = {
          ...(this.headerConfig || {}),
          derivedColumn: { ...derivedColumnFromChild },
        };
        this.$set(this.viz1, "derivedColumn", {
          ...derivedColumnFromChild,
        });
      }

      this.viz1.reportHeaderColumnDp = newHeaderMap;
      if (tableBarSqlFromChild) {
        this.$set(this.viz1, "tableBarSql", tableBarSqlFromChild);
        if (this.headerConfig) {
          this.headerConfig.tableBarSql = tableBarSqlFromChild;
        }
      }
      if (this.position && this.position.reportHeaderColumnDp !== undefined) {
        this.position.reportHeaderColumnDp = newHeaderMap;
      }
      if (
        this.position &&
        this.position.data &&
        this.position.data.reportHeaderColumnDp !== undefined
      ) {
        this.position.data.reportHeaderColumnDp = newHeaderMap;
      }
      this.recomputeReportHeaderNewColumnTitles();
    },

    rerenderTableBarWithCurrentData() {
      this.$nextTick(() => {
        const data = this.originalData || [];
        const allVizType = this.$store.state.vizType;
        const v = this.viz1;
        const vizId = v.vizletId;
        const filter = allVizType.find((t) => t.viztypeId === vizId);
        if (!filter) return;
        const vizFunction = filter.viztypeFunctionName;
        const divId = this.$refs.r1c2;
        if (!divId) return;
        this.$commonFn.renderChartCompare(
          v.viztypeName,
          this.position,
          divId,
          vizFunction,
          data,
          this.checkbox,
          this.gridflag,
          this.showValuesFlag,
        );
      });
    },

    /**
     * Report custom-column Validate preview result to VizletHeader (or screenlet relay).
     */
    notifyRatioValidatePreviewResult(result) {
      const h = this.$refs.vizletHeader;
      if (h && typeof h.onRatioValidatePreviewResult === "function") {
        h.onRatioValidatePreviewResult(result);
        return;
      }
      if (result && result.success) {
        this.$emit("column-layout-ratio-validate-success");
      } else {
        this.$emit("column-layout-ratio-validate-error", {
          message: (result && result.message) || "",
          query: result && result.query,
        });
      }
    },

    extractColumnLayoutErrorText(errorObj) {
      const d = errorObj && errorObj.response && errorObj.response.data;
      const parts = [
        d && d.message,
        d && d.error,
        d && d.errorMsg,
        d && d.details,
        errorObj && errorObj.message,
      ].filter((v) => typeof v === "string" && v.trim());
      return parts.join(" | ");
    },

    userFriendlyColumnLayoutError(errorObj, { ratioValidate = false } = {}) {
      const raw = this.extractColumnLayoutErrorText(errorObj);
      const lower = String(raw || "").toLowerCase();
      const fallback = ratioValidate
        ? "This formula could not be applied. Correct it below and click Validate again."
        : "Please correct your custom column formula, then try Preview or Save again.";

      if (!lower) return fallback;

      // Security/SQL-injection style rejections from backend/DB/proxy layers.
      if (
        lower.includes("sql injection") ||
        lower.includes("injection attack") ||
        lower.includes("malicious sql") ||
        lower.includes("invalid derived column formula") ||
        lower.includes("invalid data") ||
        lower.includes("blocked by security policy") ||
        lower.includes("query blocked by waf") ||
        lower.includes("forbidden sql pattern") ||
        lower.includes("multiple statements are not allowed") ||
        lower.includes("stacked queries are not allowed") ||
        lower.includes("tautology") ||
        lower.includes("union select") ||
        lower.includes("information_schema") ||
        lower.includes("pg_sleep")
      ) {
        return "Input contains restricted SQL keywords or unsafe characters, so the formula was blocked for security reasons. Please enter a valid column formula only.";
      }

      const quotedColumn = String(raw).match(/column\s+"([^"]+)"/i);
      const rawCol = quotedColumn && quotedColumn[1] ? quotedColumn[1] : "";
      const colName = rawCol.includes(".") ? rawCol.split(".").pop() : rawCol;

      if (lower.includes('column "') && lower.includes("does not exist")) {
        return colName
          ? `Column "${colName}" is not available. Please check the formula and use a valid column name.`
          : "One of the columns in your formula is not available. Please check the column name and try again.";
      }

      if (
        lower.includes("must appear in the group by clause") ||
        lower.includes("be used in an aggregate function")
      ) {
        return colName
          ? `Column "${colName}" must be aggregated (for example SUM/AVG) or included in GROUP BY.`
          : "A column in your formula must be aggregated (for example SUM/AVG) or included in GROUP BY.";
      }

      if (lower.includes("division by zero")) {
        return "Formula has division by zero. Please guard denominator with NULLIF(..., 0).";
      }
      if (lower.includes("invalid input syntax")) {
        return "Formula contains an invalid value/type conversion. Please check number/date/text conversions.";
      }
      if (lower.includes("operator does not exist")) {
        return "Formula uses an unsupported operator for the selected column types.";
      }
      if (lower.includes("function") && lower.includes("does not exist")) {
        return "Formula uses an unsupported function. Please verify function name and argument types.";
      }
      if (lower.includes("syntax error at or near")) {
        return "Formula syntax is invalid. Please review brackets, commas, and operators.";
      }
      if (lower.includes("value too long for type character varying")) {
        return "One value is too long for the target text field. Please shorten the value.";
      }
      if (lower.includes("cannot cast")) {
        return "Formula has an invalid type cast. Please check datatype conversions.";
      }
      if (lower.includes("null value in column") && lower.includes("violates not-null constraint")) {
        return "A required column is blank. Please provide values for all mandatory fields.";
      }

      return fallback;
    },

    /**
     * Refetch TableBar data with current `viz1.reportHeaderColumnDp` and derived columns.
     * @param {object} opts
     * @param {boolean} opts.persistHeaderConfig – if true, POST /api/viz-header-config first (Save Columns).
     * @param {boolean} opts.ratioValidate – custom formula modal: notify header instead of generic column-manager error.
     */
    async fetchTableBarDataForColumnLayout({
      persistHeaderConfig,
      ratioValidate = false,
      datasqlToSave = null,
    } = {}) {
      const newHeaderMap = this.viz1.reportHeaderColumnDp || {};
      const datasqlId = this.viz1 && this.viz1.datasqlId;

      if (!datasqlId) {
        this.rerenderTableBarWithCurrentData();
        if (ratioValidate) {
          this.notifyRatioValidatePreviewResult({ success: true });
        }
        return;
      }

      try {
        const controller = apiAbort.new();

        const allVizType = this.$store.state.vizType;
        const v = this.viz1;
        const vizId = v.vizletId;
        const filter = allVizType.find((t) => t.viztypeId === vizId);
        const vizname = filter ? filter.viztypeClassName : "Any";
        const vizValue = vizname === "ForceLayout" ? "CommonVizClass" : vizname;

        const convertedObj = this.convertValuesToStrings(
          this.$store.state.lbWhereCond[this.screenlet],
        );
        const passedParam = {
          ...convertedObj,
          ...this.filterParam,
        };

        const sqlToPersistOnSave =
          persistHeaderConfig &&
          datasqlToSave != null &&
          String(datasqlToSave).trim()
            ? String(datasqlToSave).trim()
            : null;

        if (persistHeaderConfig) {
          const vizPersist = this.viz1 || {};
          const datasqlIdStr =
            vizPersist.datasqlId != null ? String(vizPersist.datasqlId) : null;

          const menuId =
            vizPersist.menu_id ||
            (this.$route &&
              this.$route.params &&
              this.$route.params.submenuId) ||
            (this.$route && this.$route.params && this.$route.params.menuId);
          const vizletId = vizPersist.vizletId;
          if (menuId && vizletId && datasqlIdStr) {
            const derivedForPersist =
              (this.headerConfig && this.headerConfig.derivedColumn) ||
              vizPersist.derivedColumn ||
              {};
            try {
              await axios.post(
                "/api/viz-header-config",
                {
                  menuId,
                  vizletId,
                  datasqlId: datasqlIdStr,
                  reportHeaderColumnDp: newHeaderMap,
                  allHeaderColumnDp: this.effectiveAllHeaderMap || {},
                  derivedColumn: derivedForPersist,
                },
                { validateStatus: (s) => s >= 200 && s < 300 },
              );
              // Align with server row age so the 48h “new column” window resets after save.
              this.headerConfig = {
                ...(this.headerConfig || {}),
                createTimestamp: moment().format("YYYY-MM-DD HH:mm:ss.SSS"),
              };
              this.recomputeReportHeaderNewColumnTitles();
            } catch (e) {
              console.warn("viz-header-config save failed", e);
            }
          }
        }

        const fetchPayload = {
          ...passedParam,
          customization: newHeaderMap,
          vizType: "TableBar",
        };
        const tableBarSql =
          (this.headerConfig && this.headerConfig.tableBarSql) ||
          this.viz1.tableBarSql;
        if (tableBarSql && String(tableBarSql).trim()) {
          fetchPayload.tableBarSql = String(tableBarSql).trim();
        }
        const derived =
          this.headerConfig &&
          this.headerConfig.derivedColumn &&
          typeof this.headerConfig.derivedColumn === "object" &&
          Object.keys(this.headerConfig.derivedColumn || {}).length > 0
            ? this.headerConfig.derivedColumn
            : null;
        if (derived) {
          fetchPayload.derivedColumn = derived;
        }
        if (sqlToPersistOnSave) {
          fetchPayload.persistDatasql = true;
          fetchPayload.datasqlToSave = sqlToPersistOnSave;
        }
        /* Validate custom column only: light query on server; Preview/Save omit this */
        if (ratioValidate) {
          fetchPayload.previewRowLimit = 10;
        }

        const response = await axios.post(
          `/api/fetchDataWithParam/${datasqlId}/${vizValue}`,
          fetchPayload,
          {
            signal: controller.signal,
            skipGlobalDataErrorModal: true,
            headers: {
              "info-params": JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId,
              }),
              "Content-Type": "application/json",
            },
          },
        );
        console.log("response", response);

        if (sqlToPersistOnSave) {
          this.$set(this.viz1, "datasql", sqlToPersistOnSave);
          if (this.position && this.position.data) {
            this.$set(this.position.data, "datasql", sqlToPersistOnSave);
          }
        }

        const data = response.data || [];
        /* Formula validate uses LIMIT on server — do not replace table with partial rows */
        if (!ratioValidate) {
          this.originalData = data;
          this.tabulatorData = data;
          this.salesData = data;

          this.$nextTick(() => {
            const allVizType = this.$store.state.vizType;
            const vInner = this.viz1;
            const vid = vInner.vizletId;
            const filterInner = allVizType.find((t) => t.viztypeId === vid);
            if (!filterInner) return;
            const vizFunction = filterInner.viztypeFunctionName;
            const vizname = filterInner.viztypeClassName;
            const divId = this.$refs.r1c2;
            if (!divId) return;
            const convertedObj = this.convertValuesToStrings(
              this.$store.state.lbWhereCond[this.screenlet],
            );
            const passedParam = {
              ...convertedObj,
              ...this.filterParam,
            };
            this.$commonFn.renderChartCompare(
              vizname,
              this.position,
              divId,
              vizFunction,
              data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag,
              this.$store.state.resetSortFlag,
            );
          });
        }
        if (ratioValidate) {
          try {
            await this.fetchTableBarDataForColumnLayout({
              persistHeaderConfig: false,
              ratioValidate: false,
            });
            this.notifyRatioValidatePreviewResult({ success: true });
          } catch (e2) {
            console.error("Full preview after validate failed", e2);
            this.notifyRatioValidatePreviewResult({
              success: false,
              message:
                "Formula looks valid, but loading the full table failed. Click Preview or Validate again.",
            });
          }
        }
      } catch (e) {
        const msg = persistHeaderConfig
          ? "Error while fetching data after column save"
          : "Error while fetching preview column data";
        console.error("error",msg, e);
        this.rerenderTableBarWithCurrentData();
        const userMsg = this.userFriendlyColumnLayoutError(e, {
          ratioValidate,
        });
        const failedQuery = extractFailedFetchQueryFromError(e);
        if (ratioValidate) {
          this.notifyRatioValidatePreviewResult({
            success: false,
            message: userMsg,
            query: failedQuery,
          });
        } else {
          const hdr = this.$refs.vizletHeader;
          if (hdr && typeof hdr.showColumnManagerAfterFetchError === "function") {
            hdr.showColumnManagerAfterFetchError(userMsg, failedQuery);
          } else {
            this.$emit("column-layout-fetch-error", userMsg, failedQuery);
          }
        }
      }
    },

    async handlePreviewColumns(payload) {
      const ratioValidate = !!(payload && payload._ratioValidate);
      let clean = payload;
      if (payload && typeof payload === "object") {
        clean = { ...payload };
        delete clean._ratioValidate;
      }
      this.applyColumnLayoutFromPayload(clean);
      await this.fetchTableBarDataForColumnLayout({
        persistHeaderConfig: false,
        ratioValidate,
      });
    },

    async handleSaveColumns(payload) {
      this.applyColumnLayoutFromPayload(payload);
      await this.fetchTableBarDataForColumnLayout({
        persistHeaderConfig: true,
        datasqlToSave:
          payload && typeof payload === "object"
            ? payload.datasqlToSave
            : null,
      });
    },
    toggleCardWidth() {
      this.$store.commit("setFixedScreenFlag");
      this.handleResize();
    },
    handleResize() {
      this.$nextTick(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        let vizId = v.vizletId;
        let filter = allVizType.find((t) => t.viztypeId === vizId);
        let vizname = filter?.viztypeClassName;
        let vizFunction = filter?.viztypeFunctionName;
        let resetfilter = this.$store.state.resetSortFlag;

        let divId =
          this.vizTypeName === "TableBar" ? this.$refs.r1c2 : this.$refs.r1c1;

        if (!divId) {
          console.warn("DOM element for chart not ready:", this.vizTypeName);
          return;
        }

        let vizunit = v.vizletSequence;

        let getChartInfo = (vizunit) => {
          if (!v || v.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, v, v.visibleFlag, v);
        };

        this.position = getChartInfo(vizunit);

        let chartData = this.position;
        const convertedObj = this.convertValuesToStrings(
          this.$store.state.lbWhereCond[this.screenlet],
        );
        this.filtersForDashboard = convertedObj;

        let passedParam = {
          ...convertedObj,
          ...this.filterParam,
        };

        this.$commonFn.renderChartCompare(
          vizname,
          chartData,
          divId,
          vizFunction,
          this.tabulatorData,
          passedParam,
          this.checkbox,
          this.gridflag,
          this.showValuesFlag,
          resetfilter,
        );
      });
    },
    handleSearch(searchQuery) {
      // Use parameter if provided, otherwise use internal state
      const queryToUse =
        searchQuery !== undefined ? searchQuery : this.searchQuery;

      if (!queryToUse.trim()) {
        // If search is empty, show original data
        this.resetSearch();
        return;
      }

      const query = queryToUse.toLowerCase();

      if (this.viz1.viztypeName === "TableBar") {
        this.filterTableBarData(query);
      } else if (this.viz1.viztypeName === "Tabulator") {
        this.filterTabulatorData(query);
      }
    },
    filterTableBarData(query) {
      // Filter logic for TableBar
      this.filteredData = this.originalData.filter((item) => {
        return Object.values(item).some((val) =>
          String(val)
            .toLowerCase()
            .includes(query),
        );
      });
      let v = this.viz1;
      // console.log("this.viz1", this.viz1);
      this.tooltipTitle = v.highLowBetter;
      this.vizTypeName = v.viztypeName;
      // let margin = {
      //   top: v.pmTop,
      //   right: v.pmRight,
      //   bottom: v.pmBottom,
      //   left: v.pmLeft,
      // };
      let allVizType = this.$store.state.vizType;
      let vizId = v.vizletId;
      let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
      // let vizname = filter.viztypeClassName
      let vizFunction = filter.viztypeFunctionName;

      // Re-render chart with filtered data
      this.$commonFn.renderChartCompare(
        this.vizTypeName,
        this.position,
        this.$refs.r1c2,
        vizFunction,
        this.filteredData,
        // this.passedParam,
        this.checkbox,
        this.gridflag,
        this.showValuesFlag,
      );
    },
    filterTabulatorData(query) {
      // For Tabulator, we can use its built-in filtering
      if (this.$refs.tabulatorReport) {
        this.$refs.tabulatorReport.setFilter(query);
      }
    },
    resetSearch() {
      this.searchQuery = "";
      let v = this.viz1;
      this.vizTypeName = v.viztypeName;
      let allVizType = this.$store.state.vizType;
      let vizId = v.vizletId;
      let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
      let vizFunction = filter.viztypeFunctionName;
      if (this.viz1.viztypeName === "TableBar" && this.originalData) {
        // Restore original data for TableBar
        this.$commonFn.renderChartCompare(
          this.vizTypeName,
          this.position,
          this.$refs.r1c2,
          vizFunction,
          this.originalData,
          // this.passedParam,
          this.checkbox,
          this.gridflag,
          this.showValuesFlag,
        );
      } else if (
        this.viz1.viztypeName === "Tabulator" &&
        this.$refs.tabulatorReport
      ) {
        // Clear Tabulator filters
        this.$refs.tabulatorReport.clearFilter();
      }
    },
    toggleCardBody() {
      this.isCollapsed = !this.isCollapsed;
      // If you need to redraw charts when expanding
      if (!this.isCollapsed) {
        this.$nextTick(() => {
          // Redraw any charts if needed
          if (this.viz1.chart) {
            this.viz1.chart.resize().redraw();
          }
        });
      }
    },
    downloadData() {
      const v = this.viz1;
      if (v.downloadsqlId === null && v.viztypeName === 'Tabulator') {
        this.$refs['download-modal'].show();
        this.downloadLoading = true;
        const fileName = this.$store.state.user.userId + '_' + v.vizletTitleDpName + '_' + `${moment().format('YYYY-MM-DD_hhmm')}`;
        const tabulatorTable = this.$refs.tabulatorReport;
        tabulatorTable.downloadExcel(fileName);
        this.$nextTick(() => {
          this.downloadLoading = false;
          this.$refs['download-modal'].hide();
        });
        return;
      }
      this.downloadFormatChoice = 'xlsx';
      this.$refs['download-format-modal'].show();
    },

    onDownloadFormatModalShown() {
      this.downloadFormatChoice = 'xlsx';
    },

    confirmDownloadFormatModal() {
      this.pendingDownloadFormat = this.downloadFormatChoice;
      this.$refs['download-format-modal'].hide();
      this.$nextTick(() => {
        this.executeFetchCsvDownload();
      });
    },

    cancelDownloadFormatModal() {
      this.$refs['download-format-modal'].hide();
    },

    async executeFetchCsvDownload() {
      const v = this.viz1;
      const datas = this.$store.state.lbWhereCond[this.screenlet] || {};
      await runFetchCsvExport({
        downloadsqlId: v.downloadsqlId,
        datasqlId: v.datasqlId,
        reportTitle: v.vizletTitleDpName,
        postBody: datas,
        menuId: this.$route.params.menuId,
        submenuId: this.$route.params.submenuId,
        pendingDownloadFormat: this.pendingDownloadFormat,
        reportHeaderColumnDp: v.reportHeaderColumnDp,
        userId: this.$store.state.user.userId,
        tryClientTabulatorDownload: ({ fileName, onHideLoading }) => {
          if (v.viztypeName !== "Tabulator") return false;
          const tabulatorTable = this.$refs.tabulatorReport;
          if (!tabulatorTable) return false;
          tabulatorTable.downloadExcel(fileName);
          console.log("data download from viz");
          this.$nextTick(() => {
            onHideLoading && onHideLoading();
          });
          return true;
        },
        onShowLoading: () => {
          this.$refs["download-modal"].show();
          this.downloadLoading = true;
        },
        onHideLoading: () => {
          this.downloadLoading = false;
          this.$refs["download-modal"].hide();
        },
        toastError: (msg, title = "Error") => {
          this.$bvToast.toast(msg, {
            title,
            autoHideDelay: 5000,
            variant: "danger",
          });
        },
        toastInfo: (body, title) => {
          this.$bvToast.toast(body, {
            title,
            autoHideDelay: 10000,
            variant: "info",
          });
        },
        toastPollError: (msg) => this.showError(msg),
        onPollSuccess: () => this.showSuccess(),
      });
    },

    showError(message) {
      this.$bvToast.toast(message, { variant: "danger", autoHideDelay: 8000 });
    },

    showSuccess() {
      this.showErrorModal = true;
      this.title =
        "Your download has finished! You can find the file in your download folder.";
    },

    // confirmDownload() {
    //   /* if (this.viz1.viztypeName === 'Tabulator') {
    //      const tabulatorTable = this.$refs.tabulatorReport;
    //      if (tabulatorTable) {
    //        tabulatorTable.downloadCSV();
    //      }
    //    } */
    //   if (this.downloadResponse && this.downloadResponse.data.url) {
    //     // Fix the URL by removing any double slashes
    //     let downloadUrl = this.downloadResponse.data.url;
    //     if (downloadUrl.startsWith('/')) {
    //       downloadUrl = downloadUrl.substring(1); // Remove leading slash
    //     }
    //
    //     // Construct the full URL properly
    //     const baseUrl = process.env.VUE_APP_API.endsWith('/')
    //         ? process.env.VUE_APP_API.slice(0, -1)
    //         : process.env.VUE_APP_API;
    //
    //     const fullUrl = `${baseUrl}/${downloadUrl}`;
    //     window.open(fullUrl, '_blank');
    //   }
    // },
    loadViz() {
      return new Promise((resolve, reject) => {
        try {
          if (this.viz1 && this.viz1.viztypeName !== "report") {
            this.$store.dispatch("loadState").then(() => {
              // let menuData = this.$store.state.fwConfigMenuScreenRender
              let actionIconsData = this.$store.state.actionIcons;

              // ?? checking null value and assigning empty array since models.kt returns null instead of empty list
              var vizletActionIconsSyspkArray = this.viz1
                .vizletActionIconsSyspkArray
                ? this.viz1.vizletActionIconsSyspkArray
                : [];
              var mvizletActionIconsSyspkArray = this.viz1
                .mvizletActionIconsSyspkArray
                ? this.viz1.mvizletActionIconsSyspkArray
                : [];
              // var vizletActionIconsSyspkArray = currentMenuData[0].vizletActionIconsSyspkArray ? currentMenuData[0].vizletActionIconsSyspkArray : []
              var currentMenuActionIconsData = actionIconsData.filter((r) =>
                vizletActionIconsSyspkArray.includes(r.syspk),
              );
              var mCurrentMenuActionIconsData = actionIconsData.filter((r) =>
                mvizletActionIconsSyspkArray.includes(r.syspk),
              );

              // sort function for sorting the filtered currentMenuActionIconsData with the reference Array vizletActionIconsSyspkArray
              function sortFuncAI(a, b) {
                return (
                  vizletActionIconsSyspkArray.indexOf(a.syspk) -
                  vizletActionIconsSyspkArray.indexOf(b.syspk)
                );
              }

              function msortFuncAI(a, b) {
                return (
                  mvizletActionIconsSyspkArray.indexOf(a.syspk) -
                  mvizletActionIconsSyspkArray.indexOf(b.syspk)
                );
              }

              currentMenuActionIconsData.sort(sortFuncAI); //sorting the currentMenuActionIconsData
              mCurrentMenuActionIconsData.sort(msortFuncAI);
              this.currentMenuActionIconsData = currentMenuActionIconsData; //need to add in router function
              this.mCurrentMenuActionIconsData = mCurrentMenuActionIconsData;
              this.iconOnChangeFlag = Array(
                this.currentMenuActionIconsData.length,
              ).fill(true);
              if (this.$store.state.deviceType === "Mobile") {
                this.iconOnChangeFlag = Array(
                  this.mCurrentMenuActionIconsData.length,
                ).fill(true);
              }

              // this.vizletCardStyle = currentMenuData[0].vizletCardStyle
              if (typeof this.viz1.vizletCardStyle === "string") {
                // convert "min-width:30rem;" → { minWidth: '30rem' }
                this.vizletCardStyle = this.viz1.vizletCardStyle
                  .split(";")
                  .filter((s) => s.trim())
                  .reduce((acc, rule) => {
                    const [key, value] = rule.split(":");
                    if (key && value) {
                      acc[
                        key
                          .trim()
                          .replace(/-([a-z])/g, (_, c) => c.toUpperCase())
                      ] = value.trim();
                    }
                    return acc;
                  }, {});
              } else {
                this.vizletCardStyle = { ...this.viz1.vizletCardStyle };
              }
              let allVizType = this.$store.state.vizType;
              let v = this.viz1;
              this.syncTableBarHeaderBaselineIfNeeded();
              console.log("this.headerConfig", this.headerConfig);
              v.reportHeaderColumnDp = {...(this.headerConfig?.reportHeaderColumnDp ?? v.reportHeaderColumnDp)}
              this.recomputeReportHeaderNewColumnTitles();
              // console.log("this.viz1", this.viz1);
              this.tooltipTitle = v.highLowBetter;
              this.vizTypeName = v.viztypeName;
              let margin = {
                top: v.pmTop,
                right: v.pmRight,
                bottom: v.pmBottom,
                left: v.pmLeft,
              };

              let vizId = v.vizletId;
              let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
              let vizname = filter.viztypeClassName;
              let vizFunction = filter.viztypeFunctionName;
              if (this.vizTypeName == "TableBar") {
                var divId = this.$refs.r1c2;
              } else {
                divId = this.$refs.r1c1;
              }

              let vizunit = v.vizletSequence;

              let getChartInfo = (vizunit) => {
                let f = v;
                if (f.length === 0)
                  return new FwVizChartInfo(vizunit, margin, {}, false, []);
                return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
              };

              this.position = getChartInfo(vizunit);

              let chartData = this.position;

              // Convert the object
              const convertedObj = this.convertValuesToStrings(
                this.$store.state.lbWhereCond[this.screenlet],
              );
              this.filtersForDashboard = convertedObj;
              console.log("convertedObj", convertedObj);
              let passedParam = {
                ...convertedObj,
                ...this.filterParam,
              };

              const datasqlId = chartData.data.datasqlId;
              const vizValue = vizname === "ForceLayout" ? "CommonVizClass" : vizname;
              const url = `/api/fetchDataWithParam/${datasqlId}/${vizValue}`;
              let requestBody = { ...passedParam };

              const hasHeaderCustomization =
                this.headerConfig &&
                this.headerConfig.reportHeaderColumnDp &&
                typeof this.headerConfig.reportHeaderColumnDp === "object" &&
                Object.keys(this.headerConfig.reportHeaderColumnDp || {}).length > 0;

              const hasDerivedColumns =
                this.headerConfig &&
                this.headerConfig.derivedColumn &&
                typeof this.headerConfig.derivedColumn === "object" &&
                Object.keys(this.headerConfig.derivedColumn || {}).length > 0;

              if (
                this.vizTypeName === "TableBar" &&
                (hasHeaderCustomization || hasDerivedColumns)
              ) {
                const derived = hasDerivedColumns
                  ? this.headerConfig.derivedColumn
                  : null;
                requestBody = {
                  ...passedParam,
                  ...(hasHeaderCustomization
                    ? { customization: this.headerConfig.reportHeaderColumnDp }
                    : {}),
                  vizType: "TableBar",
                  ...(derived ? { derivedColumn: derived } : {}),
                };
              }
              const controller = apiAbort.new();

              axios
                .post(url, requestBody, {
                  signal: controller.signal,
                  headers: {
                    "info-params": JSON.stringify({
                      menuId: this.$route.params.menuId,
                      submenuId: this.$route.params.submenuId,
                    }),
                    "Content-Type": "application/json",
                  },
                })
                .then(async (resp) => {
                  console.log(
                    "store",
                    this.$store.state.user.userRoleRestriction
                      .menuAccessInclusionArray,
                    resp.data,
                  );
                  let restrictedArray =
                    this.$store.state.user.userRoleRestriction
                      .menuAccessInclusionArray || [];
                  let exclusionArray =
                    this.$store.state.user.userRoleRestriction
                      .menuAccessExclusionArray || [];

                  // Handle empty/undefined/null/["[]"] cases - all menus allowed
                  const isAllMenusAllowed =
                    !restrictedArray ||
                    restrictedArray.length === 0 ||
                    (restrictedArray.length === 1 &&
                      restrictedArray[0] === "[]");

                  let data =
                    chartData.title === "Browse the Menu"
                      ? resp.data.filter((item) => {
                          // If all menus are allowed, return all items
                          if (isAllMenusAllowed) {
                            return true;
                          }
                          // Check if item is in restricted array (any of the dimensions)
                          const isIncluded =
                            restrictedArray.includes(item.dim5_name) ||
                            restrictedArray.includes(item.dim6_name) ||
                            restrictedArray.includes(item.dim8_name);

                          // Check if item is NOT in exclusion array (none of the dimensions should be excluded)
                          const isNotExcluded =
                            !exclusionArray.includes(item.dim5_name) &&
                            !exclusionArray.includes(item.dim6_name) &&
                            !exclusionArray.includes(item.dim8_name);

                          // Return items that are included AND not excluded
                          return isIncluded && isNotExcluded;
                        })
                      : resp.data;

                  // Check if we should skip chart rendering for specific viztypeNames
                  const skipVizTypes = [
                    "fileUpload",
                    "salesDashboardv1",
                    "salesDashboard",
                    "Tabulator",
                    "menuConfig",
                    "aiMenuConfig",
                  ];

                  if (skipVizTypes.includes(this.viz1.viztypeName)) {
                    console.log(
                      `Skipping chart render for ${this.viz1.viztypeName}`,
                    );
                    // Set the data but don't render chart
                    this.tabulatorData = data;
                    this.originalData = data;
                    this.salesData = data;
                    this.tabFlag = true;
                    // Return early - no chart rendering
                    return;
                  }
                  // setTimeout(() => {
                  this.chartCleanup = await this.$commonFn.renderChartCompare(
                    vizname,
                    chartData,
                    divId,
                    vizFunction,
                    data,
                    passedParam,
                    this.checkbox,
                    this.gridflag,
                    this.showValuesFlag,
                  );
                  this.tabulatorData = data;
                  this.originalData = data;
                  this.salesData = data;
                  this.tabFlag = true;
                })
                .catch((error) => {
                  console.log("error", error.response.data?.error);

                  if (error.response) {
                    if (
                      Object.keys(this.filterParam || {}).length > 0 &&
                      this.selectedFilters &&
                      !this.selectedFilters?.["Viz Type"]?.Value?.["DataSQL"] &&
                      error?.response?.data?.error !== "AuthToken Exception"
                    ) {
                      // alert("Selected option is not supported");
                      console.log(
                        "filter",
                        this.filterParam,
                        this.selectedFilters,
                      );
                      this.showErrorModal = true;
                      this.title = "Selected option is not supported.";
                    }
                  } else if (error.request) {
                    // No response received from the server
                    console.error("Request error:", error.request);
                    alert(
                      "No response received from the server. Please check your connection.",
                    );
                  } else {
                    // Other errors
                    console.error("Error message:", error.message);
                    alert("An unexpected error occurred. Please try again.");
                  }
                });
            });
          }
          setTimeout(() => {
            console.log("Viz loaded for component");
            resolve();
          }, 100);
        } catch (error) {
          reject(error);
        }
      });
    },
    // Function to convert non-string values to strings, excluding null and undefined
    convertValuesToStrings(inputObj) {
      return Object.fromEntries(
        Object.entries(inputObj).map(([key, value]) => {
          if (Array.isArray(value)) {
            // Map over the array and convert each element
            return [
              key,
              value.map((item) =>
                item === null || item === undefined ? item : String(item),
              ),
            ];
          } else {
            // Handle non-array values (if any)
            return [
              key,
              value === null || value === undefined ? value : String(value),
            ];
          }
        }),
      );
    },

    svgToPng() {
      let v = this.viz1;
      var div_id;
      if (this.$refs.r1c1) {
        div_id = this.$refs.r1c1.id;
      } else div_id = this.$refs.r1c2.id;
      let svgObject = document.getElementById(div_id);
      let svgDom = svgObject.querySelector("svg");
      svgDom.style.background = "white";

      function pad2(n) {
        return n < 10 ? "0" + n : n;
      }

      var date = new Date();
      // var date_format =  date.getFullYear().toString() + pad2(date.getMonth() + 1) + pad2( date.getDate()) + pad2( date.getHours() ) + pad2( date.getMinutes() ) + pad2( date.getSeconds() ) ;
      var date_format =
        date.getFullYear().toString() +
        pad2(date.getMonth() + 1) +
        pad2(date.getDate()) +
        pad2(date.getHours()) +
        pad2(date.getMinutes());
      saveSvgAsPng(
        svgDom,
        `${v.menuId}_${v.vizletTitleDpName}_${date_format}.png`,
      );
    },
    handleActionIconFunctionCall(fnName, index) {
      let val = !this.iconOnChangeFlag[index];
      this.$set(this.iconOnChangeFlag, index, val); //Array mutation happens only by set function or other mutation methods like slice,push,pop etc
      this[fnName](this.showFSButton);
    },

    redirectPage(redirect) {
      if (redirect === true) {
        let v = this.viz1;
        window.open(v.drilldownUrl, "_blank");
      }
    },
    fullscreen(showFSButton) {
      if (showFSButton === true) {
        // console.log("fullscreen mood")
        // if (!document.fullscreenElement) {
        this.$refs.screen.requestFullscreen();
        // this.$refs.screen.classList.add('fullscreen');
        if (this.$refs.r1c1) this.$refs.r1c1.classList.add("scrollmenu"); //check whether viz is requesting FS remove its class
        if (this.$refs.r1c2) this.$refs.r1c2.classList.remove("scrollmenuRepo"); // check whether report is requesting FS remove its class
        if (this.$refs.r1c2) this.$refs.r1c2.classList.add("fullscreenRepo");
        /* } else {
             if(this.$refs.r1c1) this.$refs.r1c1.classList.remove('scrollmenu');//check whether viz is requesting FS add its class
             if(this.$refs.r1c2) this.$refs.r1c2.classList.remove('fullscreenRepo'); // check whether report is requesting FS remove its class
           //  this.$refs.screen.classList.remove('fullscreen');
             const document = window.document
             document.exitFullscreen();
         }*/
      } else {
        if (document.exitFullscreen) {
          if (this.$refs.r1c1) this.$refs.r1c1.classList.remove("scrollmenu"); //check whether viz is requesting FS add its class
          if (this.$refs.r1c2)
            this.$refs.r1c2.classList.remove("fullscreenRepo");
          if (this.$refs.r1c2) this.$refs.r1c2.classList.add("scrollmenuRepo");
          this.$refs.screen.classList.remove("fullscreen");
          document.exitFullscreen();
        }
      }
      this.showFSButton = !this.showFSButton;
    },

    commentBox: function() {
      let what = this.viz1;
      this.cmt = "";
      this.pg = what.screenTitleDpName;
      this.section = what.vizletTitleDpName;
      this.annotationHeader = "User Annotations";
      this.annotationTitle =
        this.annotationHeader + "-> " + this.pg + "-> " + this.section;
      this.$refs["comment-box"].show();
    },
    postAnnotation: function() {
      const url = "/api/annotation";
      const data = {
        userId: 1,
        userName: "Admin",
        page: this.pg,
        section: this.section,
        comment: this.cmnt,
        isBizAnnon: false,
      };
      const controller = apiAbort.new(); // 🔹 create abort controller
      axios
        .post(url, data, {
          signal: controller.signal, // 🔹 attach abort signal
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then(
          () => {
            this.$store.dispatch("loadAnnotations");
            getAnnotationMsgcount();
          },
          (e) => {
            //  this.$commonFn.auditLog(this.viz1.menuSyspk,menu, subMenu, "", "POST", e);
            console.error("error in updating annotations", e);
          },
        );
      const menuDetails = this.$store.state.menuMasterFlat.filter(
        (m) => m.menuId === this.viz1.menu_id,
      );
      // console.log("menuDetails", menuDetails);
      this.$commonFn.auditLog(
        menuDetails[0].syspk,
        this.viz1.menu_id,
        menuDetails[0].menuName,
        this.viz1.vizletTitleDpName,
        "POST",
        "Success",
        this.$store.state.deviceType,
      );
    },
    toggleCheckbox: function() {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName;
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;

        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };

        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(
          this.$store.state.lbWhereCond[this.screenlet],
        );
        let passedParam = {
          ...convertedObj,
          ...this.filterParam,
        };
        this.tabulator = passedParam;
        var url =
          "/api/fetchDataWithParam/" + chartData.data.datasqlId + "/" + vizname;
        const controller = apiAbort.new(); // 🔹 create abort controller
        axios
          .post(url, passedParam, {
            signal: controller.signal, // 🔹 attach abort signal
            headers: {
              "info-params": JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId,
              }),
              "Content-Type": "application/json",
            },
          })
          .then((resp) => {
            // setTimeout(() => {
            this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag,
            );
            // }, 300);
          })
          .catch((e) => {
            console.error("error", e);
          });
      });
      this.checkbox = !this.checkbox;
    },
    showHideValues: function() {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName;
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;

        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };

        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(
          this.$store.state.lbWhereCond[this.screenlet],
        );
        let passedParam = {
          ...convertedObj,
          ...this.filterParam,
        };
        var url =
          "/api/fetchDataWithParam/" + chartData.data.datasqlId + "/" + vizname;
        const controller = apiAbort.new(); // 🔹 create abort controller
        axios
          .post(url, passedParam, {
            signal: controller.signal, // 🔹 attach abort signal
            headers: {
              "info-params": JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId,
              }),
              "Content-Type": "application/json",
            },
          })
          .then((resp) => {
            // setTimeout(() => {
            this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag,
            );
            // }, 300);
          })
          .catch((e) => {
            console.error("error", e);
          });
      });
      this.showValuesFlag = !this.showValuesFlag;
    },
    gridlinetoggle: function() {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName;
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;
        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };
        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(
          this.$store.state.lbWhereCond[this.screenlet],
        );
        let passedParam = {
          ...convertedObj,
          ...this.filterParam,
        };
        var url =
          "/api/fetchDataWithParam/" + chartData.data.datasqlId + "/" + vizname;
        const controller = apiAbort.new(); // 🔹 create abort controller
        axios
          .post(url, passedParam, {
            signal: controller.signal, // 🔹 attach abort signal
            headers: {
              "info-params": JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId,
              }),
              "Content-Type": "application/json",
            },
          })
          .then((resp) => {
            // setTimeout(() => {
            this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag,
            );
            // }, 300);
          })
          .catch((e) => {
            console.error("error", e);
          });
      });
      this.gridflag = !this.gridflag;
    },
    forwardtoggle: function() {
      this.$store.dispatch("loadState").then(() => {
        let allVizType = this.$store.state.vizType;
        let v = this.viz1;
        let margin = {
          top: v.pmTop,
          right: v.pmRight,
          bottom: v.pmBottom,
          left: v.pmLeft,
        };

        //let vizId = v.viztypeId;
        let vizId = v.vizletId;
        let filter = allVizType.filter((t) => t.viztypeId === vizId)[0];
        let vizname = filter.viztypeClassName;
        let vizFunction = filter.viztypeFunctionName;
        let divId = this.$refs.r1c1;
        let vizunit = v.vizletSequence;

        let getChartInfo = (vizunit) => {
          let f = v;
          if (f.length === 0)
            return new FwVizChartInfo(vizunit, margin, {}, false, []);
          return new FwVizChartInfo(vizunit, margin, f, v.visibleFlag, f);
        };
        this.position = getChartInfo(vizunit);

        let chartData = this.position;

        const convertedObj = this.convertValuesToStrings(
          this.$store.state.lbWhereCond[this.screenlet],
        );
        let passedParam = {
          ...convertedObj,
          ...this.filterParam,
        };
        var url =
          "/api/fetchDataWithParam/" + chartData.data.datasqlId + "/" + vizname;
        const controller = apiAbort.new(); // 🔹 create abort controller
        axios
          .post(url, passedParam, {
            headers: {
              signal: controller.signal, // 🔹 attach abort signal
              "info-params": JSON.stringify({
                menuId: this.$route.params.menuId,
                submenuId: this.$route.params.submenuId,
              }),
              "Content-Type": "application/json",
            },
          })
          .then((resp) => {
            // setTimeout(() => {
            this.$commonFn.renderChartCompare(
              vizname,
              chartData,
              divId,
              vizFunction,
              resp.data,
              passedParam,
              this.checkbox,
              this.gridflag,
              this.showValuesFlag,
            );
            // }, 300);
          })
          .catch((e) => {
            console.error("error", e);
          });
      });
      this.forwardflag = !this.forwardflag;
    },

    fetchTotal: function() {
      setTimeout(async () => {
        if (
          this.viz1.viztypeName === "Tabulator" &&
          this.viz1.vizletMiddleTitleFlag
        ) {
          const dataSqlId = this.viz1.datasqlId;
          const controller = apiAbort.new(); // 🔹 create abort controller
          await axios
            .post(
              `/api/fetchDataWithParam/${dataSqlId}/CommonVizClass`,
              {},
              {
                signal: controller.signal, // 🔹 attach abort signal
                headers: {
                  "info-params": JSON.stringify({
                    menuId: this.$route.params.menuId,
                    submenuId: this.$route.params.submenuId,
                  }),
                  "Content-Type": "application/json",
                },
              },
            )
            .then((response) => {
              this.totalCountTabulator = response.data.length;
              this.total = this.totalCountTabulator;
            })
            .catch((e) => {
              console.error("error", e);
            });
        } else if (
          this.viz1.viztypeName === "multiplePieChart_2" &&
          this.viz1.vizletMiddleTitleFlag
        ) {
          let datas = this.$store.state.lbWhereCond[this.screenlet];
          const controller = apiAbort.new(); // 🔹 create abort controller
          axios
            .post(
              "/api/fetchDataWithParam/" + this.viz1.vizSpecific4 + "/Any",
              datas,
              {
                signal: controller.signal, // 🔹 attach abort signal
                headers: {
                  "info-params": JSON.stringify({
                    menuId: this.$route.params.menuId,
                    submenuId: this.$route.params.submenuId,
                  }),
                  "Content-Type": "application/json",
                },
              },
            )
            .then(
              (res) => {
                let data2 = res.data;
                this.total = data2.rowsData[0].metric1;
              },
              () => {},
            )
            .catch((e) => {
              console.error("error", e);
            });
        }
      }, 300);
    },
    fetchTotal2: function() {
      setTimeout(() => {
        if (
          this.viz1.viztypeName !== "multiplePieChart_2" &&
          this.viz1.vizletMiddleTitleFlag
        ) {
          let datas = this.$store.state.lbWhereCond[this.screenlet];
          const controller = apiAbort.new(); // 🔹 create abort controller
          axios
            .post(
              "/api/fetchDataWithParam/" + this.viz1.datasqlId + "/Any",
              datas,
              {
                signal: controller.signal, // 🔹 attach abort signal
                headers: {
                  "info-params": JSON.stringify({
                    menuId: this.$route.params.menuId,
                    submenuId: this.$route.params.submenuId,
                  }),
                  "Content-Type": "application/json",
                },
              },
            )
            .then(
              (res) => {
                let data2 = res.data;
                this.total = d3.sum(data2.rowsData, function(d) {
                  return d.metric1;
                });
              },
              () => {},
            )
            .catch((e) => {
              console.error("error", e);
            });
        }
      }, 300);
    },
    format: function(num) {
      if (
        this.viz1?.clientId == 3 ||
        this.viz1?.clientId == 30 ||
        this.viz1?.clientId == 40 ||
        this.viz1?.clientId == 70 ||
        this.viz1?.clientId == 5
      ) {
        if (Math.abs(num) >= 1000000000) {
          return (num / 1000000000).toFixed(2).replace(/\.0$/, "") + " HCr";
        }
        if (Math.abs(num) >= 10000000) {
          return (num / 10000000).toFixed(2).replace(/\.0$/, "") + " Cr";
        }
        if (Math.abs(num) >= 100000) {
          return (num / 100000).toFixed(2).replace(/\.0$/, "") + " L";
        }
        if (Math.abs(num) >= 1000) {
          return (num / 1000).toFixed(2).replace(/\.0$/, "") + " K";
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
          return num.toFixed(2);
        }
        return num;
      } else {
        if (Math.abs(num) >= 1000000000000) {
          return (num / 1000000000000).toFixed(1).replace(/\.0$/, "") + " T";
        }
        if (Math.abs(num) >= 1000000000) {
          return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + " B";
        }
        if (Math.abs(num) >= 1000000) {
          return (num / 1000000).toFixed(1).replace(/\.0$/, "") + " M";
        }
        if (Math.abs(num) >= 1000) {
          return (num / 1000).toFixed(1).replace(/\.0$/, "") + " K";
        }
        if (Math.abs(num) < 1000 && Math.abs(num) % 1 !== 0) {
          return num.toFixed(2);
        }
        return num;
      }
    },
  },
  created() {
    // console.log("checkinh viz ", this.vizCount)
    this.fetchTotal();
    this.fetchTotal2();
    this.format();

    this.syncTableBarHeaderBaselineIfNeeded();
    // Ensure header configuration (if any) is loaded before rendering the viz
    this.loadHeaderConfig()
      .catch(() => {
        // ignore header-config errors and proceed with default config
      })
      .then(() => {
        return this.loadViz();
      })
      .then(() => {
        console.log("loadViz from created");
        // Emit event to parent when this component finishes loading
        this.$emit("viz-loaded");
      })
      .catch((error) => {
        console.error("Error loading viz:", error);
        this.$emit("viz-loaded"); // Still emit even on error to avoid blocking
      });
  },
};
</script>
<style>
.sc-vizlet-reorder-wrap {
  position: relative;
}

.cfg-drag-handle {
  flex-shrink: 0;
  padding: 4px 6px;
  margin: 0;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  letter-spacing: -1px;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  touch-action: none;
  z-index: 6;
}

.cfg-drag-handle:hover {
  color: #3b82f6;
  border-color: #3b82f6;
}

.cfg-drag-handle:active {
  cursor: grabbing;
}

.cfg-drag-handle--widget {
  position: absolute;
  top: 8px;
  right: 8px;
  left: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.cfg-reorder-wrap--dragging {
  opacity: 0.45;
  pointer-events: none;
}

.cfg-reorder-wrap--drop {
  outline: 2px dashed #3b82f6 !important;
  outline-offset: 3px;
  box-shadow: none !important;
}

.sc-vizlet-config-selectable {
  cursor: pointer;
  transition: outline-color 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}

.sc-vizlet-config-selectable:hover:not(.sc-vizlet-config-selected) {
  outline: 1px solid color-mix(in srgb, #3b82f6 35%, transparent);
  outline-offset: 2px;
}

.sc-vizlet-config-selected {
  outline: 2px solid #3b82f6 !important;
  outline-offset: 3px;
  box-shadow: 0 4px 14px rgba(59, 130, 246, 0.18) !important;
  border-color: #93c5fd !important;
  z-index: 3;
}

.cobackground {
  fill: #eee;
}

.fixed-screen-width {
  @media (min-width: 576px) {
    width: 55vw;
  }
}

/* When vizCount == 1 */
.single-viz-height-banner-true {
  min-height: 80vh;
}

.single-viz-height-banner-false {
  min-height: 87vh;
}

/* When vizCount != 1 */
.single-viz-max-height-banner-true {
  max-height: 80vh;
}

.single-viz-max-height-banner-false {
  max-height: 87vh;
}

text.active {
  fill: red;
}

.custom-icon {
  background-color: black;
  color: white;
  border-radius: 50%;
  border: 1px solid black;
}

#full-screen {
  display: block;
  z-index: 1;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  overflow: auto;
}

.fullscreen {
  overflow: auto;
  white-space: nowrap;
  height: 500px;
}

.fullscreenRepo {
  overflow: auto;
  white-space: nowrap;
  height: 900px;
}

.scrollmenu {
  max-height: 86vh;
  overflow: auto;
}

.scrollmenu2 {
  overflow: auto;
  white-space: nowrap;
  max-height: 74vh;
}

.my-custom-tooltip1 {
  background-color: transparent !important;
  padding: 10px !important;
  border: none !important;
  box-shadow: none !important;
}

.my-custom-tooltip1 .tooltip-inner {
  border: 1px solid black;
  background-color: white;
  color: black;
  max-width: 1150px; /* Set max width */
  max-height: 300px; /* Set max height to enable scrolling */
  overflow-y: auto; /* Enable vertical scrollbar */
  pointer-events: auto; /* Allow interaction with tooltip content */
  font-size: 16px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

/* Prevent hiding the tooltip when hovering into the content */
.my-custom-tooltip1:hover {
  display: block !important; /* Ensure the tooltip stays visible */
}

.h1tag {
  font-size: 18px;
}

@media (max-width: 1500px) and (min-width: 1301px) {
  .my-custom-tooltip1 .tooltip-inner {
    max-width: 950px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1300px) and (min-width: 1251px) {
  .my-custom-tooltip1 .tooltip-inner {
    max-width: 900px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1250px) and (min-width: 1201px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 850px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1200px) and (min-width: 1151px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 800px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1150px) and (min-width: 1101px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 750px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1100px) and (min-width: 1051px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 700px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1050px) and (min-width: 1001px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 650px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 1000px) and (min-width: 951px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 600px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 950px) and (min-width: 901px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 550px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 900px) and (min-width: 851px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 500px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 850px) and (min-width: 801px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 450px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 800px) and (min-width: 768px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 420px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 768px) and (min-width: 701px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 580px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 700px) and (min-width: 651px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 530px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 650px) and (min-width: 601px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 480px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 600px) and (min-width: 551px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 420px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 550px) and (min-width: 501px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 380px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 500px) and (min-width: 481px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 350px; /* Adjust as needed for smaller screens */
    font-size: 16px;
  }

  .h1tag {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .my-custom-tooltip1 .tooltip-inner {
    width: 330px; /* Further reduce the width for very small screens */
    font-size: 16px; /* Further adjust font size for very small screens */
  }

  .h1tag {
    font-size: 18px;
  }
}

.scrollmenuRepo {
  max-height: 74vh; /*81*/
  overflow: auto;
}

.scrollmenuRepoFull {
  max-height: 81vh;
  overflow: auto;
}

[v-cloak] .v-cloak--hidden {
  display: none !important;
}

.table.table-xs td,
.table.table-xs th {
  padding: 0.2em;
  font-size: 0.8rem;
}

.screen {
  position: relative;
  resize: none;
  overflow: hidden;
  min-width: 300px;
  min-height: 200px;
}

.r1c2true {
  max-height: 74vh;
  overflow: auto;
}

.r1c2false {
  max-height: 81vh;
  overflow: auto;
}

.multi-viz {
  margin-right: 7px;
  height: 100%;
  overflow: auto;
}

.resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 20px;
  height: 20px;
  cursor: se-resize;
  font-size: 16px;
  background: rgba(255, 255, 255, 0.5);
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Border resize handles */
.resize-border {
  position: absolute;
  z-index: 5;
}

.resize-border-right {
  top: 5px;
  right: 0;
  bottom: 5px;
  width: 5px;
  cursor: e-resize;
}

.resize-border-bottom {
  bottom: 0;
  left: 5px;
  right: 5px;
  height: 5px;
  cursor: s-resize;
}

.card.resizing * {
  pointer-events: none;
}

.tab-indicator {
  font-size: 0.7em;
  padding: 3px 8px;
}

.download-format-modal-body .download-format-meta {
  padding-left: 0.15rem;
  line-height: 1.45;
}

.download-format-radios .custom-control {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

/* TableBar (D3): columns added vs screen default — lives here instead of custom.css */
th.tbc-col-head--new {
  box-shadow: inset 3px 0 0 0 #38bdf8;
  background: linear-gradient(90deg, #164e63, #0f172a) !important;
}

/* Compact “new column” marker — icon only (tooltip on parent th) */
i.tbc-header-new-icon {
  display: inline-block;
  font-size: 0.68rem;
  font-weight: 900;
  line-height: 1;
  margin-left: 0.2rem;
  vertical-align: middle;
  color: #7dd3fc;
  flex-shrink: 0;
  filter: drop-shadow(0 0 1px rgba(0, 0, 0, 0.45));
}

td.tbc-td--new {
  box-shadow: inset 3px 0 0 0 rgba(56, 189, 248, 0.65);
}
</style>
